import React, {Component} from 'react';
import AnimalFilter from '../../../AnimalList/components/AnimalFilter/AnimalFilter';
import AnimalListContainer from '../../../AnimalList/components/AnimalListContainer';
import NewProtectoraDetail from './NewProtectoraDetail';
import {LazyLoadImage} from "react-lazy-load-image-component";
import {ADS_TYPES, AdsManagerContainer} from "../../../Ads/components/AdsManagerContainer";


const ANIMALS_CONTROL = "animalsProtectora"
const ANIMALS_CONTROL_DETAIL = "animalDetailProtectora"

class NewProtectoraDetailContainer extends Component {

    constructor(props) {
        super(props);

    }

    showLoader() {
    }


    render() {
        let showAnimalList
        console.log("NewProtectoraDetailContainer::render()")
        const nombreProtectora = (this.props.infoProtectoraDetail) ? this.props.infoProtectoraDetail.nombre : undefined;
        const espeiceSeleccionada = (this.props.filter && this.props.filter.especieSeleccionada && this.props.filter.especieSeleccionada !== "ambos") ? this.props.filter.especieSeleccionada.toLowerCase() + "s" : "animales"

        if(this.props.animalsProtectora && this.props.animalsProtectora.animals && this.props.animalsProtectora.animals.length >0){
            showAnimalList = true
        }

        return (
            <div id="animals-list" className="container main-content">

                {(this.props.showCardProtectoraDetail) ? (
                    <div>
                        <NewProtectoraDetail
                            infoProtectoraDetail={this.props.infoProtectoraDetail}
                            animalsControl={this.props.animalsControl}
                            animalsControlDetail={this.props.animalsControlDetail}
                            isAdminAnimals={this.props.isAdminAnimals}
                            access={this.props.access}
                        />
                    </div>
                ) : (
                    <div/>
                )}
                <AdsManagerContainer type={ADS_TYPES.ROBAPAGINAS}/>

                <div className="protectora-detail__heading">
                    {this.props.access.isLogin
                    && this.props.access.id === this.props.params.id
                    && !this.props.showCardProtectoraDetail
                        ? (
                            <h2>Estos son los {espeiceSeleccionada} en que tienes registrados</h2>
                        ) : (
                            <h2>Estos son los {espeiceSeleccionada} en adopción de {nombreProtectora}</h2>
                        )
                    }
                </div>
                <div className="row">
                    <div id="" className="col-lg-3">
                        <AnimalFilter
                            loader={this.showLoader.bind(this)}
                            loadData={this.props.loadAnimals}
                            isAdminAnimals={this.props.isAdminAnimals}

                            filterControl={"filtersControlProtectora"}
                            varsData={
                                {id_protectora: this.props.infoProtectoraDetail._id}
                            }
                        />
                        <AdsManagerContainer type={ADS_TYPES.SPLITSCREEN} onlyDesktop/>

                    </div>
                    <div id="loaderImage">
                        <LazyLoadImage threshold={150} src=""/>
                        <div className="loaderImageText">B U S C A N D O . . .</div>
                    </div>

                    {/*{showAnimalList &&*/}
                    <div id="animals-list-container" className="col-lg-9">
                        <AnimalListContainer
                            list={this.props.animalsProtectora.animals}
                            totalRecord={this.props.animalsProtectora.totalRecord}
                            pag={this.props.animalsProtectora.pag}
                            loadAnimals={this.props.loadAnimals}
                            elementsPerRow={this.props.elementsPerRow}
                            elementsPerPage={this.props.elementsPerPage}
                            animalsControl={ANIMALS_CONTROL}
                            animalsControlDetail={ANIMALS_CONTROL_DETAIL}
                            isAdminAnimals={this.props.isAdminAnimals}
                            access={this.props.access}
                        />
                    </div>
                    {/*}*/}
                </div>
                <AdsManagerContainer type={ADS_TYPES.BILLBOARD}/>

            </div>
        );
    }

    componentWillMount() {

    }
    componentDidMount() {
        this.showLoader();
    }

    componentDidUpdate() {
        if (this.props.waitBlock.showWaitBlock) {
            $('#modal-container').removeClass('out').addClass("one");
            $('body').addClass('modal-active');
        } else {
            $('body').removeClass('modal-active');
        }
    }


}


//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default  NewProtectoraDetailContainer
